const SemVer = require('../classes/semver')
const major = (a, loose) => new SemVer(a, loose).major
module.exports = major



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/major.js
// module id = 1922
// module chunks = 1